module.exports = __webpack_public_path__ + "static/media/create-event-active-icon.3a0cc622.svg";